// src/utils/withSanitizedOnChange.ts
import React from "react";
import ReactDOM from "react-dom";
import { sanitizeXML } from "./xmlSanitizer";
import type { ChangeEvent } from "react";
import { MessageBar, MessageBarType } from "office-ui-fabric-react";

type InputEvent = ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

let _msgContainer: HTMLDivElement | null = null;

function showCleanupMessage() {
  if (!_msgContainer) {
    _msgContainer = document.createElement("div");
    // fixed at top of viewport
    Object.assign(_msgContainer.style, {
      position: "fixed",
      top: "0",
      left: "0",
      width: "100%",
      zIndex: "10000"
    });
    document.body.prepend(_msgContainer);
  }

  const onDismiss = () => {
    if (_msgContainer) {
      ReactDOM.unmountComponentAtNode(_msgContainer);
      _msgContainer.remove();
      _msgContainer = null;
    }
  };

  ReactDOM.render(
    React.createElement(
      MessageBar,
      {
        messageBarType: MessageBarType.error,
        isMultiline: false,
        dismissButtonAriaLabel: "Close",
        overflowButtonAriaLabel: "See more",
        onDismiss,
        // ensure it spans full width inside container
        styles: { root: { margin: 0, borderRadius: 0 } }
      },
      "Some unsupported characters were removed. These characters are not compatible with reports and have been automatically cleaned."
    ),
    _msgContainer
  );
}

export function withSanitizedOnChange(
  originalOnChange?: (e: InputEvent) => void
): (e: InputEvent) => void {
  return (e) => {
    const raw = e.target.value;
    const { cleaned } = sanitizeXML(raw);
    if (cleaned !== raw) {
      e.target.value = cleaned;
      showCleanupMessage();
    }
    originalOnChange?.(e);
  };
}
